import './subsubnav.scss';

export function SubSubNav({ menuitems, onChange, selected, id, style }) {
  return (
    <div className="subsubnav" style={style} id={id || 'sub-sub-nav'}>
      {menuitems.map((menuItem) => (
        <div
        key={`${menuItem.icon}-${menuItem.title}`}
          onClick={() => onChange(menuItem)}
          className={`subsubnav-item ${
            menuItem.title === selected ? 'active' : "" 
          }`}
        >
          <div className="icon">
            {menuItem?.icon === 'unicons' ? (
              menuItem?.image
            ) : (
              <></>
            )}
          </div>
          <div className="title capitalize">{menuItem?.title}</div>
          {menuItem?.count > 0 && (
            <div className="subsubnav-count">{menuItem.count}</div>
          )}
        </div>
      ))}
    </div>
  );
}
